let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cEVfr")).then(() => parcelRequire('lQaob'));